import type { ProProUpsellInfo } from 'hellospa/components/upsell/dropbox-pro-pro/types';
import { getEndpointResource, postJSONEndpointResource } from 'hello-react/web-app-client/namespace/admin/endpoints';

export async function fetchProProUpsellInfo(): Promise<ProProUpsellInfo> {
  const result: any = await getEndpointResource('/upsell/getProProHomeUpsellInfo');

  if (!result.success) {
    return {
      showBanner: false,
      showModal: false,
      variation: '',
      goalType: '',
      coolDownKey: '',
      bannerRedirectUrl: '',
      modalRedirectUrl: '',
      isEligible: false,
      planName: '',
    };
  }

  const {
    data: {
      showBanner,
      showModal,
      variation,
      goalType,
      coolDownKey,
      bannerRedirectUrl,
      modalRedirectUrl,
      isEligible,
      planName,
    },
  } = result;

  return {
    showBanner,
    showModal,
    variation,
    goalType,
    coolDownKey,
    bannerRedirectUrl,
    modalRedirectUrl,
    isEligible,
    planName,
  };
}

export async function triggerProProUpsellBannerCoolDown(
  coolDownName: string,
  ttl: number = 1209600, // 2 Weeks in seconds
) {
  return postJSONEndpointResource('/upsell/startCooldown', {
    body: JSON.stringify({
      cooldown_name: coolDownName,
      time_to_live: ttl,
    }),
  });
}

export async function markSubscriptionGoalComplete(goalType: string) {
  return postJSONEndpointResource('/upsell/markSubscriptionGoalComplete', {
    body: JSON.stringify({
      subscription_goal_type_code: goalType,
    }),
  });
}
